import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Params} from '@angular/router';
import {Person} from '../../shared/types/person/person';
import {PersonRestService} from '../../shared/services/person/person-rest.service';
import {FileUtilsService} from '../../shared/services/common/file/file-utils.service';
import {FileRestService} from '../../shared/services/common/file/file-rest.service';
import * as moment from 'moment';
import {ExportRestService} from '../../shared/services/export/export-rest.service';
import {SecurityRestService} from '../../shared/services/security/security-rest.service';
import {Editable} from '../../shared/types/security/editable';
import * as FileSaver from 'file-saver';
import {Location} from '@angular/common';
import {ContactVisibility} from '../../shared/types/contact/contact-visibility';
import {User} from '../../shared/types/security/user';

@Component({
  selector: 'wsd-person-detail',
  templateUrl: './person-detail.component.html',
  styleUrls: ['./person-detail.component.css']
})
export class PersonDetailComponent implements OnInit, OnDestroy {

  person: Person;
  imageSrc: any;
  display = {};

  editable: boolean;

  personNotFound: boolean = false;

  private routeSub: Subscription;

  isSomeVisibleContacts: boolean = false;

  user: User;

  loggedUser: Person;

  constructor(private personRestService: PersonRestService,
              private fileRestService: FileRestService,
              private exportService: ExportRestService,
              private fileUtilsService: FileUtilsService,
              private location: Location,
              private route: ActivatedRoute,
              private securityRestService: SecurityRestService) {
  }

  ngOnInit() {
    this.routeSub = this.route.params.subscribe(
      (params: Params) => this.loadPerson(params)
    );
    this.securityRestService.getCurrentUser().subscribe((user: User) => {
        this.user = user;
        if (this.user.consultantId) {
          this.personRestService.getPersonFromAllPersons(this.user.consultantId).subscribe((loggedPerson: Person) => {
            this.loggedUser = loggedPerson;
          });
        }
      }
    );
  }

  private loadPerson(params: Params) {
    if (params['id']) {
      this.personRestService.getPerson(+params['id']).subscribe(
        (data: Person) => {
          this.person = data;
          this.getNumberOfVisibleContacts(data);
          this.loadImage(this.person.profileImageId);
        },
        () => {
          this.personNotFound = true;
        }
      );
      this.securityRestService.getEditablePerson(+params['id']).subscribe(
        (data: Editable) => {
          this.editable = data.editable;

        }
      );
    }
  }

  private loadImage(imgId: number) {
    if (!imgId) {
      return;
    }
    this.fileRestService.getImage(imgId.toString()).subscribe(
      ((data: any) => {
        this.imageSrc = this.fileUtilsService.getImage(data.content);
      })
    );
  }

  getFullName() {
    return [
      this.person.title,
      this.person.firstName,
      this.person.middleName,
      this.person.lastName,
      this.person.suffix,
      this.person.honours
    ].filter(Boolean).join(' ');
  }

  getNumberOfVisibleContacts(person: Person) {
    this.isSomeVisibleContacts = false;
    if (person.contacts) {
      for (let i = 0; i < person.contacts.length; i++) {
        if (this.person.contacts[i].visibleInDirectory === ContactVisibility.VISIBLE_TO_WORLD_BUREAU_STAFF_AND_USERS) {
          this.isSomeVisibleContacts = true;
          return;
        }
      }
    }
  }

  formatDateToNow(dateStr) {
    return moment.isDate(dateStr) ? moment(dateStr).toNow() : 'unknown';
  }

  exportCard(type: string, consultantId: number, titleId: number) {
    this.display[titleId] = false;
    this.exportService.generateCard(type, consultantId, titleId).subscribe(
      res => FileSaver.saveAs(res.blob, res.filename),
      this.exportService.noop
    );
  }

  goBack() {
    this.location.back();
  }

  ngOnDestroy(): void {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }


  showContact(contact: any): boolean {

    if (contact == null) {
      return false;
    }

    if (typeof contact === "string") {
      this.person.contacts.forEach((userContact) => {
        if (contact === userContact.value) {
          contact = userContact;
        }
      });
    }

    if (this.loggedUser != null) {
      for (const i in this.loggedUser.roles) {
        const role = this.loggedUser.roles[i].roleName;

        if (contact.visibleInDirectory === ContactVisibility.VISIBLE_TO_WORLD_BUREAU_STAFF_AND_USERS) {
          return true;
        }

        if (role === 'ROLE_WSD_STAFF' || role === 'ROLE_WSD_REGIONAL_GROUP_ADMIN' || role === 'ROLE_WSD_WORLD_GROUP_ADMIN') {
          return true;
        }

        if (contact.visibleInDirectory === ContactVisibility.VISIBLE_TO_WORLD_BUREAU_STAFF && role === 'ROLE_WSD_NSO_GROUP_ADMIN') {
          if (this.person.organization.name === this.loggedUser.organization.name) {
            return true;
          }
        }

        if ((contact.visibleInDirectory === ContactVisibility.VISIBLE_TO_WORLD_BUREAU_STAFF_AND_USERS_FROM_REGION)
          && (role === 'ROLE_WSD_INTRANET' || role === 'ROLE_WSD_NSO_GROUP_ADMIN' || role === 'ROLE_WSD_WORLD_COMMITTEES')) {
          if (this.person.region.name === this.loggedUser.region.name) {
            return true;
          }
        }
      }
    }

    return false;
  }
}
